export default __webpack_public_path__ + "static/media/Cloudxier-whychooseus-01.9cb9bcb4.png";